export default __webpack_public_path__ + "media/images/dog-time-f1913bea8e2086106fa9153238a21115.png";